import DataImportFormTabs from '../../../components/3modules/DataImportFormTabs'
import PeopleImportTemplate from '../../../components/5templates/PeopleImportTemplate'
import {useNavigate, useParams} from 'react-router-dom'
import {useState} from 'react'


const ApprovePeopleForm = () => {
    const navigate = useNavigate()
    const id = useParams().id
    const [selectedContactList, setSelectedContactList] = useState({})

    const onNext = () => {
        navigate(`/approveLocation/service/${id}`)
    }

    const onPrev = () => {
        navigate(`/approveLocation/location/${id}`)
    }


    return(
        <DataImportFormTabs flow={'addLocation'}>
            <PeopleImportTemplate selectedContactList={selectedContactList}
                                  setSelectedContactList={setSelectedContactList}
                                  onPrev={onPrev}
                                  onNext={onNext}
                                  disabled />
        </DataImportFormTabs>
    )
}

export default ApprovePeopleForm
